<script>
	import { onMount } from 'svelte';

	import Preloader from './Preloader.svelte';
	import Header from './Header.svelte';
	import Hero from './Hero.svelte';
	import Equalizer from './Equalizer.svelte';
	import Contacts from './Contacts.svelte';

	let intro = true;

	function switchPreloader() {
		setTimeout(() => {
			intro = false;
		}, 2900);
	}

	onMount(switchPreloader);
</script>

<svelte:head>
	<link rel="preconnect" href="https://fonts.googleapis.com" />
	<link rel="preconnect" href="https://fonts.gstatic.com" crossorigin />
	<link
		href="https://fonts.googleapis.com/css2?family=Montserrat:wght@400;700&display=swap"
		rel="stylesheet"
	/>" rel="stylesheet">
</svelte:head>

<main id="particles-js">
	{#if intro}
		<Preloader />
	{:else}
		<Header />
		<Hero />
		<Equalizer />
		<Contacts />
	{/if}
</main>

<style>
	:global(body) {
		overflow: hidden;
		padding: 0;
		margin: 0;
		width: 100%;
		height: 100%;
		color: #f5f5f5;
		background: #191919;
		text-align: center;
		box-sizing: border-box;
		font-family: 'Montserrat', sans-serif;
	}
	:global(html) {
		overflow: hidden;
		padding: 0;
		margin: 0;
		width: 100%;
		height: 100%;
	}

	main {
		position: relative;
		width: 100%;
		height: 100vh;
		background: #000;
		text-align: center;
		background: url(/images/main-bg.jpg) center no-repeat;
		background-size: cover;
	}

	@media (min-width: 640px) {
		main {
			max-width: none;
		}
	}
</style>
